import { Component, OnInit } from '@angular/core';
import { MapService } from '../map.service';
import { NgForOf } from '@angular/common';

@Component({
  standalone: false,  // this is now required when using NgModule
  selector: 'app-featureinfoview',
  templateUrl: './featureinfoview.component.html',
  styleUrls: ['./featureinfoview.component.css']
})
export class FeatureinfoviewComponent implements OnInit {

  constructor(public mapService: MapService) { }

  ngOnInit(): void {
  }
}
